import React from "react";
import css from "./HollowButton.module.scss";

export type HollowButton = React.PropsWithChildren & {
  onClick?: () => void;
  style?: React.CSSProperties;
};
export function HollowButton(props: HollowButton) {
  return (
    <div
      className={css.HollowButton}
      style={props.style}
      onClick={props.onClick}
      data-testid={props["data-testid"]}
    >
      {props.children}
    </div>
  );
}
